import React, { useEffect } from 'react';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import * as copy from './copy';
import * as styles from './NoSearchResults.styles';

interface NoSearchResultsProps {
  searchTerm: string;
}

export const NoSearchResults = ({ searchTerm }: NoSearchResultsProps) => {
  useEffect(() => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Search page',
      event_action: 'zero search results',
      event_label: searchTerm,
    });
  }, []);

  return (
    <div css={styles.noSearchResultsWrapper}>
      <h1 css={styles.heading}>
        <span css={styles.headingText}>{copy.HEADING}</span>
        <span css={styles.headingTerm}>&quot;{searchTerm}&quot;</span>
      </h1>
      <p css={styles.info}>{copy.TRY_AGAIN_INFO}</p>
    </div>
  );
};
